import { Component, Injector, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'credit-differe',
    templateUrl: './credit-differe.component.html',
    styleUrls: ['./credit-differe.component.scss'],
    standalone: false
})
export class CreditDiffereComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
    const differe = this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('loan')
      .get('differe');

    if (!differe.value || differe.value !== 'AUCUN') {
      this.form
        .get('products')
        .get('0')
        .get('parameters')
        .get('loan')
        .get('durationDiffereInMonth')
        .setValidators(Validators.required);

      this.form
        .get('products')
        .get('0')
        .get('parameters')
        .get('loan')
        .get('durationDiffereInMonth')
        .updateValueAndValidity();
    }

    this.form
      .get('products')
      .get('0')
      .get('parameters')
      .get('loan')
      .get('differe')
      .valueChanges.subscribe(value => {
        if (value === 'AUCUN') {
          this.form
            .get('products')
            .get('0')
            .get('parameters')
            .get('loan')
            .get('durationDiffereInMonth')
            .clearValidators();
          this.form
            .get('products')
            .get('0')
            .get('parameters')
            .get('loan')
            .get('durationDiffereInMonth')
            .updateValueAndValidity();
        } else {
          this.form
            .get('products')
            .get('0')
            .get('parameters')
            .get('loan')
            .get('durationDiffereInMonth')
            .setValidators(Validators.required);
          this.form
            .get('products')
            .get('0')
            .get('parameters')
            .get('loan')
            .get('durationDiffereInMonth')
            .updateValueAndValidity();
        }
      });
  }
  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  onDiffereChange(event) {}
}
